import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'
import { cn } from './cn'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** 検証エラー状態。aria-invalid と danger ボーダーを付与 */
  error?: boolean
}

// border/focus/error 表現は本コンポーネントが確定（利用側 className での上書き対象外）。
// 入力欄の既定表現（border 1.5px #ddd・角丸 field=8px・focus:border-primary）。Select/Textarea/Combobox と共通。
const BASE =
  'w-full px-4 py-2 rounded-field border-[1.5px] transition-colors ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'

const NORMAL = 'border-[#ddd] focus:border-primary focus-visible:ring-primary'
const ERROR = 'border-danger focus:border-danger focus-visible:ring-danger'

/**
 * 単一行テキスト入力。
 * label 関連付け（htmlFor/id もしくは aria-label）は利用側責務。
 * aria-invalid / focus リングは本コンポーネントが担保。
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { error = false, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={error || undefined}
      className={cn(BASE, error ? ERROR : NORMAL, className)}
      {...rest}
    />
  )
})
